import React from "react";

import styles from "./style.module.css";

const COLOR_FULL = "#512F77";
const COLOR_HIGHLIGHT = "#EF7E54";
const COLOR_EMPTY = "#DCD9EE";

const STATUS = {
  FULL: "full",
  HIGHLIGHT: "highlight",
  EMPTY: "empty"
};

const STEP_TOTAL = 10;

function createIndicatorArr(stepNum, stepTotal = 10) {
  const stepArr = [];
  const stepRotation = 360 / stepTotal;
  for (let i = 0; i < stepTotal; i++) {
    const currStep = {
      rotation: stepRotation * i + "deg"
    };
    if (i + 1 === stepNum) {
      currStep.status = STATUS.HIGHLIGHT;
    } else if (i + 1 < stepNum) {
      currStep.status = STATUS.FULL;
    } else {
      currStep.status = STATUS.EMPTY;
    }
    stepArr.push(currStep);
  }
  return stepArr;
}

export default class ProgressIndicator extends React.PureComponent {
  render() {
    const { stepNum, stepTotal, size, style } = this.props;

    const stepArr = createIndicatorArr(stepNum, stepTotal || STEP_TOTAL);
    const inlineStyling = {};
    if (size) {
      inlineStyling.height = size + "px";
      inlineStyling.width = size + "px";
    }

    return (
      <div className={styles.progressIndicatorWrapper} style={style ? style : {}}>
        <div className={styles.progressIndicator} style={inlineStyling}>
          {stepArr.map((step, i) => (
            <ProgressUnit key={i} status={step.status} rotation={step.rotation} radius={size} />
          ))}
        </div>
      </div>
    );
  }
}

class ProgressUnit extends React.PureComponent {
  render() {
    const { radius, rotation, style, status } = this.props;
    const inlineStyling = {};
    if (radius) {
      inlineStyling.height = radius;
    }
    if (rotation) {
      inlineStyling.transform = "rotate(" + rotation + ")";
    }

    return (
      <div className={styles.progressUnit} style={style ? { ...inlineStyling, ...style } : inlineStyling}>
        <ProgressDot status={status} size={(radius / 10) * 2} />
      </div>
    );
  }
}

class ProgressDot extends React.PureComponent {
  render() {
    const { size, color, status } = this.props;
    const inlineStyling = {
      backgroundColor: color
    };
    if (!color) {
      switch (status) {
        case STATUS.FULL:
          inlineStyling.backgroundColor = COLOR_FULL;
          break;
        case STATUS.HIGHLIGHT:
          inlineStyling.backgroundColor = COLOR_HIGHLIGHT;
          break;
        case STATUS.EMPTY:
        default:
          inlineStyling.backgroundColor = COLOR_EMPTY;
      }
    }
    if (size) {
      inlineStyling.height = size;
      inlineStyling.width = size;
    }

    return (
      <div className={styles.progressDotWrapper}>
        <div className={styles.progressDot} style={inlineStyling}></div>
      </div>
    );
  }
}
